module.exports = __webpack_public_path__ + "static/media/cleaner.cf878483.jpg";